import { HttpServiceBase } from "./http-service-base";

export class GrantService extends HttpServiceBase {
  get(applicationId) {
    return new Promise((resolve, reject) => {
      this.http
        .get(`v1/grants?applicationId=${applicationId}`)
        .then((message) => JSON.parse(message.response))
        .then((grants) => resolve(grants))
        .catch((e) => reject(e));
    });
  }
}
